import script from "./FamilyGroupScope.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupScope.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupScope.vue?vue&type=style&index=0&id=d86f61dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d86f61dc"]])

export default __exports__